import {CommandBase} from "./commandBase";
import {BuildingReward, RemoteConstantsModel} from "../models/remoteConstants.model";
import {mintNamespacedUid} from "../utils/uid.utils";

// Appends a default BuildingReward to a building's passiveRewards. Default
// shape: OnPlace trigger granting 0 Gold — minimum-viable card that the user
// fills in via the editor UI.
export class AddBuildingPassiveRewardCommand extends CommandBase {
    buildingId: string;

    constructor(buildingId: string) {
        super();
        this.buildingId = buildingId;
    }

    execute(data: RemoteConstantsModel): boolean {
        const building = data.buildings.find(b => b.id === this.buildingId);
        if (!building) return false;

        const reward: BuildingReward = {
            // e.g. "building.city.passivereward.0" — the uid is only an
            // internal per-building state key, but readable beats UUID.
            uid: mintNamespacedUid(building.id, 'passivereward',
                (building.passiveRewards ?? []).map(r => r.uid)),
            active: true,
            trigger: {kind: 'OnPlace'},
            grant: {kind: 'Gold', amount: 0},
            amountIncreasePerTrigger: 0,
        };

        building.passiveRewards = [...(building.passiveRewards ?? []), reward];
        return true;
    }
}
